<div id="wrapper">
  <app-loading-screen [status]=true></app-loading-screen>
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive"></app-menu>
    <div class="basicrow mbott">
      <div class="container">
        <div class="fulltitle m-top-i f-btitle">
          <i class="fa fa-briefcase" aria-hidden="true"></i> {{this.companyName}}
        </div>
        <div class="basicrow m-top">
          <div class="autowcont m-bott">
            <div class="basicrow msidespad border-bottom">
              <div class="b-title noline">
                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                  <div class="tabcell">
                    Descarga Tu Factura
                  </div>
                </div>
              </div>
            </div>
            <div class="basicrow">
              <div class="basicrow allpads">
                <div class="basicrow">
                  <div class="autorow subsc pull-left mob-wid">
                    <label class="label-r">Filtro de Búsqueda:</label>
                    <div class="basicrow">
                      <select (change)="updateBillsChange()" [(ngModel)]="selectBan" class="sel-f"
                        style="background-image:url(/assets/images/selectabarrw.png)">
                        <option disabled value="">N&uacute;mero de Cuenta</option>
                        <option *ngFor="let account of this.banlist" [ngValue]="account.account">{{account.account}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="autorow subsc pull-left mleft-select">
                    <label class="label-r">Año:</label>
                    <div class="basicrow">
                      <select (change)="updateBillsChange()" [(ngModel)]="selectYear" class="sel-f yearSelect"
                        style="background-image:url(/assets/images/selectabarrw.png)">
                        <option disabled value="">Año</option>
                        <option *ngFor="let year of this.yearList" [ngValue]="year">{{year}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="autorow subsc pull-left mleft-select">
                    <label class="label-r">Formato:</label>
                    <div class="basicrow">
                      <select (change)="updateBillsChange()" [(ngModel)]="format" class="sel-f yearSelect"
                        style="background-image:url(/assets/images/selectabarrw.png)">
                        <option disabled value="">Formato</option>
                        <option value="pdf">PDF</option>
                        <option value="csv">CSV</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="basicrow msidespad roboto-b f-black f-reg m-bott">
                <div class="basicrow topbord">
                  Factura Actual
                </div>
              </div>
              <div class="basicrow visible-web">
                <div class="tab-tbar">
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      Fecha de Facturaci&oacute;n
                    </div>
                  </div>
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      Vencimiento
                    </div>
                  </div>
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      Cantidad
                    </div>
                  </div>
                  <div class="frwds vcenter">
                    <div class="tabcell">
                      Ver Como
                    </div>
                  </div>
                </div>
                <div class="basicrow">
                  <div class="notData" *ngIf="this.invoices.length==0">No hay datos disponibles.</div>
                  <!-- repeat -->
                  <div class="tab-cbar" *ngFor="let invoice of this.invoices; let i = index">
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        {{invoice.BillDate}}
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell" *ngIf="invoice.DueDate!='--'">
                        {{invoice.DueDate}}
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell" *ngIf="invoice.AmountDue!='--'">
                        ${{invoice.AmountDue}}
                      </div>
                    </div>
                    <div class="frwds vcenter">
                      <div class="tabcell">
                        <div class="actbtn" *ngIf="this.format=='pdf'">
                          <a (click)="this.openPDF(invoice.key,invoice.BillDate)">
                            <i data-toggle="popover" data-html="true" data-content="PDF" data-placement="top"
                              data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="actbtn" *ngIf="this.format=='csv'">
                          <a (click)="this.openCVS(invoice.key,invoice.BillDate)">
                            <i data-toggle="popover" data-html="true" data-content="CSV" data-placement="top"
                              data-trigger="hover" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- [INIT TABLA MOVIL] -->
              <div class="basicrow m-top visible-movil">
                <div class="basicrow mbott-i" id="last-div">
                  <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                    <!-- Indicators -->
                    <ol class="carousel-indicators bot-select">
                      <li data-target="#myCarousel5" data-slide-to="0" class="active"></li>
                      <li data-target="#myCarousel5" data-slide-to="1"></li>
                    </ol> 
                    <!-- Wrapper for slides -->
                    <div class="carousel-inner">
                      <carousel [interval]="false">
                        <slide>
                          <div class="item active">
                            <div class="boxtbl">
                              <div class="tab-tbar">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    Fecha de Facturaci&oacute;n
                                  </div>
                                </div>
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    Vencimiento
                                  </div>
                                </div>
                              </div>
                              <div class="basicrow">
                                <div class="tab-cbar" ng-repeat="bill in vm.bills"
                                  *ngFor="let invoice of this.invoices; let i = index">
                                  <div class="frwds rline vcenter">
                                    <div class="tabcell">
                                      {{invoice.BillDate}}
                                    </div>
                                  </div>
                                  <div class="frwds vcenter">
                                    <div class="tabcell" *ngIf="invoice.DueDate!='--'">
                                      {{invoice.DueDate}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </slide>
                        <slide>
                          <div class="item">
                            <div class="boxtbl">
                              <div class="tab-tbar">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    Cantidad
                                  </div>
                                </div>
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    Ver Como
                                  </div>
                                </div>
                              </div>
                              <div class="basicrow">
                                <div class="tab-cbar" ng-repeat="bill in vm.bills"
                                  *ngFor="let invoice of this.invoices; let i = index">
                                  <div class="frwds rline vcenter">
                                    <div class="tabcell" *ngIf="invoice.AmountDue!='--'">
                                      ${{invoice.AmountDue}}
                                    </div>
                                  </div>
                                  <div class="frwds vcenter">
                                    <div class="tabcell">
                                      <div class="actbtn">
                                        <a (click)="this.openPDF(invoice.key,invoice.BillDate)"
                                          *ngIf="this.format=='pdf'">
                                          <i data-toggle="popover" data-html="true" data-content="PDF"
                                            data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o"
                                            aria-hidden="true"></i>
                                        </a>
                                        <a (click)="this.openCVS(invoice.key,invoice.BillDate)"
                                          *ngIf="this.format=='csv'">
                                          <i data-toggle="popover" data-html="true" data-content="PDF"
                                            data-placement="top" data-trigger="hover" class="fa fa-file-pdf-o"
                                            aria-hidden="true"></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </slide>
                      </carousel>
                    </div>
                  </div>
                </div>
              </div>
              <!-- [END TABLA MOVIL] -->
            </div>
          </div>
          <div class="basicrow m-top-u allpads bordsdef f-reg roboto-r f-black text-justify">
            <span class="roboto-b">
              <label style="font-size: 18px; padding-bottom: 10px;">
                Servicio al Cliente
              </label> 
              <div>
                Ayuda y soporte
              </div>
            </span>
            <div>
              Para cualquier duda o pregunta sobre el servicio o producto que requiera, que se le está ofreciendo o esté considerando, comuníquese con su Oficial de Relaciones con Cliente vía correo electrónico a <a href="mailto:wholesalegroup@claropr.com" target="black_">wholesalegroup@claropr.com</a>.
            </div>
          </div>
          <div class="basicrow m-top-i bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify">
            <span class="roboto-b">Hist&oacute;rico de facturas</span><br /><br />
            <div>
              El hist&oacute;rico de facturas le permite ver hasta sus &uacute;ltimas trece (13) facturas.
            </div>
            <div>
              Para revisarlas sólo se necesita seleccionar el formato [PDF o CSV] en que desea ver la factura y luego bajo la columna Ver Como oprimir el botón. El sistema le permite ver las primeras quinientas (500) páginas de la factura, cuando aplique.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>